// Changes automatically on every production build. It can be overridden for
// a release with VITE_APP_VERSION (for example: 1.4.0).
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || __APP_VERSION__;
